class StraProductVariant extends HTMLElement {
  constructor() {
    super();
    this.selectedVariant = null;
    this.addToCartButton = null;
  }

  connectedCallback() {
    // Get all variant bubbles inside this component
    const variantBubbles = this.querySelectorAll('.stra-bubble[data-variant-id]');
    this.addToCartButton = this.querySelector('.stra-bubble a[data-action="add-to-cart"]');

    // Insert error message container if not present
    if (!this.querySelector('.stra-variant-error')) {
      const errorDiv = document.createElement('div');
      errorDiv.className = 'stra-variant-error';
      errorDiv.style.display = 'none';
      errorDiv.style.color = '#d32f2f';
      errorDiv.style.padding = '0.7em 1em';
      errorDiv.style.fontSize = '1.3rem';
      errorDiv.style.textAlign = 'right';
      errorDiv.style.transition = 'opacity 0.2s';
      errorDiv.textContent = '';
      this.insertBefore(errorDiv, this.firstChild);
    }

    // Add click handlers to variant bubbles
    variantBubbles.forEach((bubble) => {
      bubble.addEventListener('click', () => this.handleVariantSelection(bubble, variantBubbles));
    });

    // Add click handler to add to cart button
    if (this.addToCartButton) {
      this.addToCartButton.addEventListener('click', (e) => this.handleAddToCart(e));
    }
  }

  handleVariantSelection(selectedBubble, allBubbles) {
    // If clicking the same variant again, deselect it
    if (this.selectedVariant === selectedBubble.dataset.variantId) {
      selectedBubble.classList.remove('active');
      this.selectedVariant = null;
      // Reset add to cart button states
      if (this.addToCartButton) {
        this.addToCartButton.classList.remove('loading', 'added', 'error');
      }
      return;
    }

    // Remove active class from all bubbles
    allBubbles.forEach((bubble) => bubble.classList.remove('active'));

    // Add active class to selected bubble
    selectedBubble.classList.add('active');

    // Store the selected variant
    this.selectedVariant = selectedBubble.dataset.variantId;

    // Reset add to cart button states when selecting a new variant
    if (this.addToCartButton) {
      this.addToCartButton.classList.remove('loading', 'added', 'error');
    }

    // Hide error message if present
    const errorDiv = this.querySelector('.stra-variant-error');
    if (errorDiv) {
      errorDiv.style.display = 'none';
      errorDiv.textContent = '';
    }
  }

  async handleAddToCart(e) {
    e.preventDefault();

    if (!this.selectedVariant) {
      // Show error message instead of alert
      const errorDiv = this.querySelector('.stra-variant-error');
      if (errorDiv) {
        errorDiv.textContent = 'Please select a variant.';
        errorDiv.style.display = 'block';
      }
      return;
    }

    // Add loading state before request
    this.addToCartButton.classList.add('loading');
    this.addToCartButton.classList.remove('added', 'error');

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          items: [
            {
              id: this.selectedVariant,
              quantity: 1,
            },
          ],
        }),
      });

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      // Fetch updated cart sections for drawer and bubble
      const sections = ['stra-cart-drawer', 'cart-icon-bubble'];
      const sectionsUrl = window.location.pathname;
      const cartSectionsResp = await fetch('/?sections=' + sections.join(',') + '&sections_url=' + encodeURIComponent(sectionsUrl));
      const cartSections = await cartSectionsResp.json();

      // Update cart drawer
      const cartDrawerEl = document.querySelector('cart-drawer');
      if (cartDrawerEl && cartSections['stra-cart-drawer']) {
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = cartSections['stra-cart-drawer'];
        const newCartDrawer = tempDiv.querySelector('cart-drawer');
        if (newCartDrawer) {
          cartDrawerEl.replaceWith(newCartDrawer);
          if (window.customElements && window.customElements.upgrade) {
            window.customElements.upgrade(newCartDrawer);
          }
        } else {
          // fallback: update innerHTML of the old element
          cartDrawerEl.innerHTML = cartSections['stra-cart-drawer'];
        }
      }

      // Update cart icon bubble
      const cartBubble = document.querySelector('#cart-icon-bubble');
      if (cartBubble && cartSections['cart-icon-bubble']) {
        cartBubble.innerHTML = cartSections['cart-icon-bubble'];
      }

      // Remove loading and add success state
      this.addToCartButton.classList.remove('loading');
      this.addToCartButton.classList.add('added');
      setTimeout(() => {
        this.addToCartButton.classList.remove('added');
        // Reset selection after add to cart
        this.selectedVariant = null;
        // Remove 'active' class from all variant bubbles
        const variantBubbles = this.querySelectorAll('.stra-bubble[data-variant-id]');
        variantBubbles.forEach((bubble) => bubble.classList.remove('active'));
      }, 2000);
    } catch (error) {
      console.error('Error:', error);
      // Show error state
      this.addToCartButton.classList.remove('loading', 'added');
      this.addToCartButton.classList.add('error');

      // Reset to original state after 2 seconds
      setTimeout(() => {
        this.addToCartButton.classList.remove('error');
      }, 2000);
    }
  }
}

customElements.define('stra-product-variant', StraProductVariant);